import React from 'react';
import { Box, Container, Grid, Typography, Stack, Divider, IconButton, Button } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import GitHubIcon from '@mui/icons-material/GitHub';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <Box sx={{ bgcolor: '#F1F5F9', pt: 10, pb: 4, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
      <Container maxWidth="xl">
        <Grid container spacing={6}>
          <Grid item xs={12} md={4}>
            <Box
              onClick={() => scrollToSection('home')}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                mb: 4
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 900,
                  color: '#0F172A',
                  letterSpacing: '-1px',
                  fontSize: '2rem',
                  lineHeight: 1
                }}
              >
                Niti<Box component="span" sx={{ color: 'primary.main' }}>X</Box>
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 800,
                  color: 'primary.main',
                  letterSpacing: '0.5px',
                  fontSize: '0.75rem',
                  mt: 0.5
                }}
              >
                AI & DATA INTELLIGENCE FOR GOVERNANCE
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 2, mb: 4, maxWidth: 300 }}>
              The intelligence layer powering the future of governance. Bringing together data, intelligence, and automation for sovereign public systems.
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton color="primary" sx={{ bgcolor: 'rgba(0,0,0,0.03)', '&:hover': { bgcolor: 'primary.main', color: '#fff' } }}><LinkedInIcon /></IconButton>
              <IconButton color="primary" sx={{ bgcolor: 'rgba(0,0,0,0.03)', '&:hover': { bgcolor: 'primary.main', color: '#fff' } }}><TwitterIcon /></IconButton>
              <IconButton color="primary" sx={{ bgcolor: 'rgba(0,0,0,0.03)', '&:hover': { bgcolor: 'primary.main', color: '#fff' } }}><GitHubIcon /></IconButton>
            </Stack>
          </Grid>

          <Grid item xs={6} md={2}>
            <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 3 }}>Platforms</Typography>
            <Stack spacing={1.5}>
              <Box onClick={() => scrollToSection('technology')} sx={{ color: '#64748B', cursor: 'pointer', fontSize: '0.85rem', '&:hover': { color: 'primary.main' } }}>Technology</Box>
              <Box onClick={() => scrollToSection('platform')} sx={{ color: '#64748B', cursor: 'pointer', fontSize: '0.85rem', '&:hover': { color: 'primary.main' } }}>Architecture</Box>
              <Box onClick={() => scrollToSection('solutions')} sx={{ color: '#64748B', cursor: 'pointer', fontSize: '0.85rem', '&:hover': { color: 'primary.main' } }}>Solutions</Box>
              <Box onClick={() => scrollToSection('use-cases')} sx={{ color: '#64748B', cursor: 'pointer', fontSize: '0.85rem', '&:hover': { color: 'primary.main' } }}>Use Cases</Box>
            </Stack>
          </Grid>

          <Grid item xs={6} md={2}>
            <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 3 }}>Resources</Typography>
            <Stack spacing={1.5}>
              <Box onClick={() => scrollToSection('about')} sx={{ color: '#64748B', cursor: 'pointer', fontSize: '0.85rem', '&:hover': { color: 'primary.main' } }}>Our Vision</Box>
              <Box onClick={() => scrollToSection('insights')} sx={{ color: '#64748B', cursor: 'pointer', fontSize: '0.85rem', '&:hover': { color: 'primary.main' } }}>Insights</Box>
              <Box onClick={() => scrollToSection('case-studies')} sx={{ color: '#64748B', cursor: 'pointer', fontSize: '0.85rem', '&:hover': { color: 'primary.main' } }}>Case Studies</Box>
              <Box onClick={() => scrollToSection('partners')} sx={{ color: '#64748B', cursor: 'pointer', fontSize: '0.85rem', '&:hover': { color: 'primary.main' } }}>Partners</Box>
              <Box onClick={() => scrollToSection('careers')} sx={{ color: '#64748B', cursor: 'pointer', fontSize: '0.85rem', '&:hover': { color: 'primary.main' } }}>Careers</Box>
            </Stack>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box sx={{ p: 4, bgcolor: 'rgba(0,124,255,0.03)', borderRadius: 2, border: '1px solid rgba(0,124,255,0.1)' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 2, color: 'text.primary' }}>Ready to Transform?</Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>Schedule a consultation with our governance AI experts.</Typography>
              <Button variant="contained" fullWidth sx={{ borderRadius: '8px', fontWeight: 800, py: 1.5 }} onClick={() => scrollToSection('contact')}>Start Conversation</Button>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ mt: 8, mb: 4, opacity: 0.1 }} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            © {new Date().getFullYear()} Nitix AI. All Rights Reserved. | DPDP & ISO Certified | v1.1
          </Typography>
          <Stack direction="row" spacing={3}>
            <Typography variant="caption" sx={{ color: 'text.secondary', cursor: 'pointer' }}>Privacy Policy</Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary', cursor: 'pointer' }}>Terms of Service</Typography>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
